import { render, staticRenderFns } from "./ReasonComponent.vue?vue&type=template&id=89b73662&"
import script from "./ReasonComponent.vue?vue&type=script&lang=js&"
export * from "./ReasonComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports